
document.addEventListener("DOMContentLoaded", function(){

  const openBtn = document.querySelector(".open-video-popup");
  const popup = document.getElementById("videoPopup");
  const closeBtn = document.getElementById("closeVideoPopup");

  const videoDesktop = document.getElementById("popupVideoDesktop");
  const videoMobile = document.getElementById("popupVideoMobile");

  // Safety check
  if(!openBtn || !popup) return;

  function isMobile(){
    return window.innerWidth < 768;
  }

  function getActiveVideo(){
    if(isMobile() && videoMobile) return videoMobile;
    if(!isMobile() && videoDesktop) return videoDesktop;
    return null;
  }

  openBtn.addEventListener("click", function(){
    popup.style.display = "flex";
    const video = getActiveVideo();
    if(video){
      video.play();
    }
  });

  closeBtn.addEventListener("click", function(){
    popup.style.display = "none";

    if(videoDesktop){
      videoDesktop.pause();
      videoDesktop.currentTime = 0;
    }
    if(videoMobile){
      videoMobile.pause();
      videoMobile.currentTime = 0;
    }
  });

  // Click outside popup closes it
  popup.addEventListener("click", function(e){
    if(e.target === popup){
      closeBtn.click();
    }
  });

});
